var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AlertCardWrapper',{attrs:{"actionTitle":_vm.actionTitle,"titleArr":_vm.titleArr,"alert":_vm.alert},on:{"action-button-click":_vm.actionButtonClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }